import React from 'react'
import _ from 'lodash';
import { connect } from 'react-redux'
import { StatusClosedPage1 } from 'manager/views/components/ReferralStatus/StatusClosedPage1'
import { StatusClosedPage2 } from 'manager/views/components/ReferralStatus/StatusClosedPage2'

const ClosedForm = ({ currentPage }) => {
  return currentPage === 1 ? <StatusClosedPage1 /> : <StatusClosedPage2 />
}

const selector = state => {
  const currentPage = _.get(state, ['referralStatus', 'currentPage'], 1)
  return { currentPage }
}

export const StatusClosedForm = connect(selector)(ClosedForm)
